import { Directive, ElementRef } from '@angular/core';

/**
 * NavItemLinkDirective
 */
@Directive({
  selector: '[ecpNavLink]',
  standalone: false,
})
export class NavItemLinkDirective {
  /**
   * constructor
   * @param {ElementRef} element
   */
  constructor(public element: ElementRef) {}
}
